import React from 'react';
import { Typography, CircularProgress, makeStyles } from '@material-ui/core';
import StatusIcon from '../StatusIcon';
import { observer } from 'mobx-react-lite';

const useStyles = makeStyles((theme) => ({
  meta: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 4,
    fontSize: 11,
    color: '#667781',
    width: '100%',
    justifyContent: 'flex-end',
    verticalAlign: 'bottom',
    marginTop: theme.spacing(0.5),
  },
}));

export default observer(function MessageMeta({ message, fmtTimeID }) {
  const classes = useStyles();
  const isOptimistic = message?.isOptimistic;

  return (
    <span className={classes.meta}>
      {message.provider !== 'bailey' && (
        <Typography variant="caption" color="textSecondary">
          Sent via Superkos |
        </Typography>
      )}
      <Typography variant="caption" color="textSecondary">
        {fmtTimeID(message.timestamp)}
      </Typography>
      {message.fromMe && (
        <StatusIcon 
          status={isOptimistic ? (message.status || 'sending') : (message.status || 'sent')} 
          isOptimistic={isOptimistic}
        />
      )}
      {isOptimistic && message.status === 'sending' && (
        <CircularProgress size={12} style={{ marginLeft: 4 }} />
      )}
    </span>
  );
});